
import { useCallback } from "react";
import { ContentItem } from "../../../content-card/types";
import { GraphNode } from "./useGraphTypes";

export const useGraphNodeBuilder = () => {
  const buildGraphNodes = useCallback((
    contentItems: ContentItem[],
    contentToCollectionMap: Record<string, string>,
    collectionColorMap: Record<string, string>,
    selectedNode: string | null
  ): GraphNode[] => {
    console.log(`Processing ${contentItems.length} content items for network visualization`);
    
    const nodes: GraphNode[] = contentItems.map(item => {
      // First try to get color directly from the content item (most reliable source)
      let nodeColor = item.collection_color;
      
      // If no color on the item itself, try to get it from the collection map
      if (!nodeColor) {
        const collectionId = contentToCollectionMap[item.id] || item.collection_id;
        if (collectionId && collectionColorMap[collectionId]) {
          nodeColor = collectionColorMap[collectionId];
        }
      }
      
      // Default color if no color found
      const finalColor = nodeColor || "#6B7789";
      
      console.log(`Node ${item.id} (${item.title}): Using color ${finalColor}, from item: ${item.collection_color}, collection_id: ${item.collection_id}`);
      
      return {
        id: item.id,
        name: item.title,
        color: finalColor,
        size: 15, // Consistent size for all nodes now
        thumbnailUrl: item.thumbnail_url || '',
        contentType: item.content_type,
        isSelected: false, // No more selection
        collectionId: contentToCollectionMap[item.id] || item.collection_id,
        isHighlighted: false // No more highlighting
      };
    });

    console.log(`Created ${nodes.length} graph nodes`);
    return nodes;
  }, []);

  return { buildGraphNodes };
};
